export default "__VITE_ASSET__930fbad6__"